import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { adminActions } from '../../actions';
import useDispatch from '../../hooks/useDispatch';
import ShortkeyListener from './ShortkeyListener';

const ForcePaymentShortkeys: React.FC = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const callback = useCallback(
    key => {
      if (key === 'ctrl+p') {
        dispatch(adminActions.togglePaymentView);
      }
    },
    [dispatch]
  );

  const shortkeys = useMemo(
    () => [
      {
        section: 'admin',
        key: 'ctrl+p',
        description: t('toggle-payment-view'),
      },
    ],
    [t]
  );

  return (
    <ShortkeyListener
      handleKeys={['ctrl+p']}
      onKeyEvent={callback}
      shortkeys={shortkeys}
    />
  );
};

export default React.memo(ForcePaymentShortkeys);
